/**
 * ISO ("1949-07-19") -> "19.07.1949", for the date of birth field
 * (addProfileSettings.tsx). A plain string split, not `new Date(iso)`: a
 * bare "YYYY-MM-DD" parses as UTC midnight, which prints the previous day
 * in a negative-UTC-offset timezone. Same as champis-exhibitions' and
 * champis-events' own formatDate() (with parseDate(), copied: the
 * extensions don't depend on each other).
 */
export default function formatDate(iso) {
  if (!iso) return iso;
  const [year, month, day] = iso.split('-');
  if (!year || !month || !day) return iso;
  return `${day}.${month}.${year}`;
}
flarum.reg.add('champis-users', 'forum/utils/formatDate', formatDate);